import Policy from './Policy'

export default Policy
